import React from 'react';
import { observer } from 'mobx-react';
import { GroupStore } from '@seedlang/stores';
import cx from 'classnames';
import styled from '@emotion/styled';
import { AppUI, ForumUI } from '@seedlang/state';
import { isPresent } from '@seedlang/utils';
import { Constants } from '@seedlang/constants';
import { Link } from 'react-router';

const Wrapper = styled.div`
  .group-show {
    display: flex;
    .fa-copy {
      font-size: 20px;
    }
    .target-edit {
      display: flex;
      .fa-edit {
        cursor: pointer;
        margin: 3px 5px 0 0;
        display: inline-block;
      }
    }
    label {
      font-size: 12px;
      text-transform: uppercase;
    }
    .col-xs-2, .col-xs-12, .col-xs-10, .col-xs-6 {
      padding: 0;
    }
    input[type="text"] {
      margin: 0;
    }
    .left {
      width: 160px;
      margin-right: 10px;
      border-top: 1px solid #CCC;
      .group-nav {
        background: #e8e8e8;
        display: block;
        width: 100%;
        border-right: 1px solid #CCC;
        border-left: 1px solid #CCC;
        border-bottom: 1px solid #CCC;
        font-size: 14px;
        padding: 5px 10px;
        cursor: pointer;
        &.selected {
          background: #FFF;
        }
      }
    }
    .right {
      flex: 1;
    }
  }
`;

const Section = styled.div`
  background: #CCC;
  font-size: 12px;
  font-weight: bold;
  padding-left: 10px;
`;

const NotificationCircle = styled.div`
  background: #d67c00;
  border-radius: 100px;
  color: white;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
`;

@observer
class GroupShow extends React.Component {
  constructor(props) {
    super(props);
    GroupStore.getShow({ids: {groupId: AppUI.groupId}});
    if (!ForumUI.hasForum && AppUI.user?.site?.showWorksheetComments && isPresent(AppUI.user.site.forumId)) {
      ForumUI.loadForum(AppUI.user.site.forumId);
    }
  }

  render() {
    const routeName = this.props.children?.props?.route?.name || '';
    return (
      <Wrapper>
      <div className='group-show'>
        <div className='left'>
          {
            (AppUI.user.currentUserGroup?.canAccessAdminPosts) &&
              <div>
                <Section>
                  Posts
                </Section>
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.worksheets'),
                  })}
                  to='creator.worksheets.index'
                >
                  Posts
                </Link>
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.exercises'),
                  })}
                  to='creator.exercises.index'
                >
                  Exercises
                </Link>
                {
                  AppUI.user?.site?.hasPodcast &&
                    <Link
                      className={cx('group-nav', {
                        selected: routeName.startsWith('creator.podcast_episodes'),
                      })}
                      to='creator.podcast_episodes.index'
                    >
                      Podcast Episodes
                    </Link>
                }
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.tags'),
                  })}
                  to='creator.tags.index'
                >
                  Post & Exercise Tags
                </Link>
                {
                  !AppUI.site.language?.hasLessons &&
                  <Link
                    className={cx('group-nav', {
                      selected: routeName.startsWith('creator.concepts'),
                    })}
                    to='creator.concepts.index'
                  >
                    Word Tags
                  </Link>
                }
                {
                  AppUI.user?.site?.showWorksheetComments &&
                    <Link
                      className={cx('group-nav', {
                        selected:
                          routeName.startsWith('creator.worksheet.comments') ||
                          routeName.startsWith('creator.forum_threads'),
                      })}
                      to='creator.worksheet.comments'
                    >
                      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                        Comments
                        {
                          ForumUI.hasForum && ForumUI.forum.uncheckedThreadsCount > 0 &&
                            <NotificationCircle>{ForumUI.forum.uncheckedThreadsCount}</NotificationCircle>
                        }
                      </div>
                    </Link>
                }
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.emails'),
                  })}
                  to='creator.emails.index'
                >
                  Send Email
                </Link>
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.custom_tabs'),
                  })}
                  to='creator.custom_tabs'
                >
                  Custom Tabs
                </Link>
              </div>
          }
          {
            AppUI.user.currentUserGroup?.canAccessAdminUsers &&
              <div>
                <Section>
                  User Management
                </Section>
                {
                  AppUI.permissions?.canAccessBasicUserData &&
                    <Link
                      className={cx('group-nav', {
                        selected: routeName.startsWith('creator.users'),
                      })}
                      to='creator.users.index'
                    >
                      Users
                    </Link>
                }
                {
                  AppUI.permissions?.canAccessAdmins &&
                    <>
                      <Link
                        className={cx('group-nav', {
                          selected: routeName.startsWith('creator.admins.index'),
                        })}
                        to='creator.admins.index'
                      >
                        Admins
                      </Link>
                    </>
                }
                {
                  AppUI.permissions?.canAccessBasicUserData &&
                    <Link
                      className={cx('group-nav', {
                        selected: routeName.startsWith('creator.subscriptions'),
                      })}
                      to='creator.subscriptions.index'
                    >
                      Subscriptions
                    </Link>
                }
              </div>
          }
          {
            AppUI.user.currentUserGroup?.canAccessAdminSite &&
              <div>
                <Section>
                  Site Setup
                </Section>
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.download_link_types'),
                  })}
                  to='creator.download_link_types.index'
                >
                  Download Links
                </Link>
                <Link
                  className={cx('group-nav', {
                    selected: routeName === 'creator.site_layout',
                  })}
                  to='creator.site_layout'
                >
                  Site Settings
                </Link>
                {
                  GroupStore.hasShowData && isPresent(GroupStore.showData.site?.languageId) && !Constants.LANGUAGE_ABBREVIATIONS.includes(GroupStore.showData.site?.languageId) &&
                    <Link
                      className={cx('group-nav', {
                        selected: routeName === 'creator.language.edit',
                      })}
                      to={{name: 'creator.language.edit', params: {languageId: GroupStore.showData.site?.languageId}}}
                    >
                      Language Settings
                    </Link>
                }
                <Link
                  className={cx('group-nav', {
                    selected: routeName === 'creator.site_navigation' || routeName === 'creator.navigation_items.edit',
                  })}
                  to='creator.site_navigation'
                >
                  Site Navigation
                </Link>
                <Link
                  className={cx('group-nav', {
                    selected: routeName === 'creator.worksheet_settings',
                  })}
                  to='creator.worksheet_settings'
                >
                  Post Settings
                </Link>
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.grid_items'),
                  })}
                  to='creator.grid_items.index'
                >
                  Grid Sections
                </Link>
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.site_pages'),
                  })}
                  to='creator.site_pages'
                >
                  Custom Pages
                </Link>
                <Link
                  className={cx('group-nav', {
                    selected:
                      routeName.startsWith('creator.membership_groups') ||
                      routeName.startsWith('creator.memberships'),
                  })}
                  to='creator.membership_groups'
                >
                  Membership Groups
                </Link>
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.membership_types'),
                  })}
                  to='creator.membership_types.index'
                >
                  Membership Types
                </Link>
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.campaign'),
                  })}
                  to='creator.campaign_types.index'
                >
                  Automated Emails
                </Link>
                {AppUI.site.enableMailerlite &&
                  <Link
                    className={cx('group-nav', {
                      selected: routeName.startsWith('creator.mailerlite_groups'),
                    })}
                    to='creator.mailerlite_groups.index'
                  >
                    MailerLite Groups
                  </Link>
                }
                <Link
                  className={cx('group-nav', {
                    selected: routeName.startsWith('creator.banner_notices'),
                  })}
                  to='creator.banner_notices.index'
                >
                  Banner Notices
                </Link>
                {
                  AppUI.user?.site?.hasPodcast &&
                    <Link
                      className={cx('group-nav', {
                        selected: routeName.startsWith('creator.podcasts'),
                      })}
                      to='creator.podcasts.index'
                    >
                      Podcasts
                    </Link>
                }
                {
                  AppUI.site.allowPatreonSignIn &&
                    <Link
                      className={cx('group-nav', {
                        selected: routeName.startsWith('creator.payment_migration'),
                      })}
                      to='creator.payment_migration.index'
                    >
                      Payment Migration
                    </Link>
                }
              </div>
          }
          <Section>
            Analytics
          </Section>
          <Link
            className={cx('group-nav', {
              selected: routeName === 'creator.dashboard',
            })}
            to='creator.dashboard'
          >
            Dashboard
          </Link>
          {
            AppUI.site?.published &&
              <Link
                className={cx('group-nav', {
                  selected: routeName === 'creator.analytics',
                })}
                to='creator.analytics'
              >
                Analytics
              </Link>
          }
          <Link
            className={cx('group-nav', {
              selected: routeName === 'creator.exercise.ratings',
            })}
            to='creator.exercise.ratings'
          >
            Exercise Ratings
          </Link>
        </div>
        <div className='right'>
          {this.props.children}
        </div>
      </div>
      </Wrapper>
    );
  }
}

export default GroupShow;
